<template>
  <div
    v-if="showBookForm"
    class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
  >
    <section
      class="w-full mx-auto max-w-7xl flex justify-center items-center relative p-2 md:p-0"
    >
      <div
        class="bg-white w-[510px] md:h-[500px] px-5 py-7 rounded-lg relative"
      >
        <button
          @click="closeForm"
          class="absolute top-0 right-0 -mt-4 -mr-4 p-2 bg-gray-200 rounded-full hover:bg-gray-300 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <p class="text-3xl font-semibold">Download Document</p>
        <form @submit.prevent="submitForm">
          <div class="flex flex-col gap-4 items-center pt-5">
            <div
              class="w-full border border-slate-300 h-12 rounded-lg flex items-center"
            >
              <input
                type="text"
                name="name"
                id="name"
                autocomplete="off"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 flex lg:pl-5 pl-2"
                maxlength="255"
                minlength="1"
                placeholder="Enter Name *"
                required
                v-model="name"
              />
            </div>
            <div
              class="w-full border border-slate-300 h-12 rounded-lg flex items-center"
            >
              <input
                class="w-full border-none focus:outline-none focus:ring-0 lg:pl-5 pl-2"
                type="email"
                name="email"
                id="email"
                autocomplete="off"
                maxlength="50"
                placeholder="Enter Email Address *"
                required
                v-model="email"
              />
            </div>
            <div class="flex justify-center items-center gap-2 md:gap-4 w-full">
              <div class="border border-slate-300 rounded-lg w-[20%]">
                <select
                  v-model="selectedCountryCode"
                  class="form-control widget_input text-center h-12 w-[57px] md:w-[85px] bg-white rounded-lg"
                >
                  <option
                    v-for="country in countryCodes"
                    :key="country.code"
                    :value="country.code"
                  >
                    {{
                      selectedCountryCode === country.code
                        ? country.code
                        : `${country.name} (${country.code})`
                    }}
                  </option>
                </select>
              </div>
              <div class="border border-slate-300 h-12 rounded-lg flex w-[80%]">
                <input
                  type="tel"
                  name="mobile"
                  id="Mobile"
                  autocomplete="off"
                  maxlength="10"
                  class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 lg:pl-5 pl-2 rounded-lg"
                  pattern="[0-9]*"
                  placeholder="Enter Mobile Number *"
                  @keypress="handleKeyPress"
                  v-model="phoneNumber"
                  required
                />
                <!-- <p
                  class="absolute right-8 pt-4 text-xs"
                  :class="{
                    'text-[#0A2767]': !otpCooldown,
                    'text-green-700': otpCooldown,
                    'cursor-pointer': !otpCooldown && phoneNumber.length === 10,
                    'opacity-50 cursor-not-allowed':
                      otpCooldown || phoneNumber.length !== 10,
                  }"
                  @click="getOtp"
                  :disabled="otpCooldown || phoneNumber.length !== 10"
                >
                  {{ otpCooldown ? "OTP Sent" : "Get OTP" }}
                </p> -->
              </div>
            </div>
            <!-- <div
              class="w-full border border-slate-300 h-12 rounded-lg flex items-center"
            >
              <input
                type="tel"
                name="otp"
                id="otp"
                autocomplete="off"
                maxlength="6"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 lg:pl-5 pl-2"
                pattern="[0-9]*"
                placeholder="Enter OTP *"
                v-model="enteredOtp"
                @input="sanitizeInput"
                required
              />
            </div>
            <div
              v-if="submissionStatus === 'otpError'"
              class="text-red-500 text-xs text-left pl-0 mt-1"
            >
              Invalid OTP
            </div> -->
            <div class="w-full flex flex-col gap-4">
              <div class="flex items-center lg:gap-4 gap-2 md:gap-3">
                <div
                  class="border border-slate-300 h-12 rounded-lg lg:w-[50%] w-[40%] flex items-center justify-between px-4"
                >
                  <span class="w-full text-center font-semibold">{{
                    randomNumber
                  }}</span>
                  <button @click="generateRandomNumber" class="icon-button">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 4v6h6M20 20v-6h-6"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 10a8 8 0 0116 0M20 14a8 8 0 01-16 0"
                      />
                    </svg>
                  </button>
                </div>
                <input
                  type="text"
                  class="border border-slate-300 h-12 rounded-lg lg:w-[50%] w-[60%] px-4"
                  v-model="userInput"
                  :maxlength="randomNumber.length"
                  @input="validateInput"
                  placeholder="Enter number as shown"
                />
              </div>
              <p
                v-if="showError"
                class="text-red-500 text-sm -mt-3 text-right mr-8 md:mr-16"
              >
                Invalid number
              </p>
            </div>
            <div
              class="box-border text-[14px] leading-normal text-start text-[#333] p-1"
            >
              <label class="flex items-start space-x-2">
                <input
                  type="checkbox"
                  name="consent"
                  class="mt-1 focus:ring-blue-500"
                  required
                />
                <span>
                  I authorize JAIN Online and its associates to contact me with
                  updates & notifications via email, SMS, WhatsApp, and voice
                  call. This consent will override any registration for
                  DNC/NDNC.
                </span>
              </label>
            </div>
            <div
              class="box-border text-[14px] leading-normal text-[#333] text-center p-1"
            >
              <button
                type="submit"
                class="w-full px-16 py-3 bg-[#0A2767] text-[#F8C300] font-semibold text-2xl rounded-md focus:outline-none focus:bg-blue-700"
              >
                Download Now
              </button>
            </div>
          </div>
        </form>
        <div>
          <span
            v-if="submissionStatus === 'error'"
            class="text-red-500 text-xs"
            >{{ errorMessage }}</span
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import countryCodeMixins from "@/mixins/countryCodeMixins";

export default {
  name: "DocumentView",
  mixins: [countryCodeMixins],
  props: ["url", "description"],
  data() {
    return {
      randomNumber: "",
      userInput: "",
      showError: false,
      showBookForm: true,
      name: "",
      email: "",
      phoneNumber: "",
      enteredOtp: "",
      otpSent: false,
      errorStatus: false,
      errorMessage: "",
      selectedCountryCode: "+91",
      submissionStatus: "",
      otpCooldown: false,
    };
  },
  mounted() {
    this.generateRandomNumber();
  },
  methods: {
    generateRandomNumber() {
      this.randomNumber = Math.floor(
        100000 + Math.random() * 900000
      ).toString();
      this.userInput = "";
      this.showError = false;
    },
    validateInput() {
      if (this.userInput.length === this.randomNumber.length) {
        this.showError = this.userInput !== this.randomNumber;
      }
    },
    closeForm() {
      this.showBookForm = false;
      this.$emit("close-button", this.showBookForm);
      this.resetForm();
    },
    sanitizeInput() {
      this.enteredOtp = this.enteredOtp.replace(/\D/g, "");
    },
    handleChange() {
      this.selectedCountryCode = this.$refs.countryCodeSelect.value;
    },
    handleKeyPress(event) {
      const keyCode = event.keyCode || event.which;
      const keyValue = String.fromCharCode(keyCode);
      if (!/^\d+$/.test(keyValue)) {
        event.preventDefault();
      }
    },
    async submitForm() {
      this.errorStatus = false;
      this.submissionStatus = "";

      // Check if the userInput matches the random number
      if (this.userInput !== this.randomNumber) {
        this.showError = true;
        this.submissionStatus = "randomNumberError";
        return;
      }

      try {
        const formData = {
          name: this.name,
          email: this.email,
          phone: `${this.selectedCountryCode}${this.phoneNumber}`,
          utmCampaign: this.$route.query.utm_campaign || "",
          utmSource: this.$route.query.utm_source || "",
          utmMedium: this.$route.query.utm_medium || "",
          utmPlacement: this.$route.query.utm_placement || "",
          utmAdgroupId: this.$route.query.utm_adgroupid || "",
          utmCreativeId: this.$route.query.utm_creativeid || "",
          utmDevice: this.$route.query.utm_device || "",
          utmNetwork: this.$route.query.utm_network || "",
          utmCampaignId: this.$route.query.utm_campaignid || "",
          utmMatchType: this.$route.query.utm_matchype || "",
          utmKeyword: this.$route.query.utm_keyword || "",
          utmChannel: "Elective-Documents" || "",
          utmURL: window.location.href || "",
        };

        const response = await axios.post(
          `${process.env.VUE_APP_LEADAPI}/lead/`,
          formData
        );

        const responseData = response.data;
        if (responseData.lead && responseData.lead.success === true) {
          this.submissionStatus = "success";
          this.showBookForm = false;

          // PDF download logic
          if (this.url) {
            const a = document.createElement("a");
            a.href = this.url;
            a.target = "_blank";
            const filename = this.url.split("/").pop();
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }

          // Redirect to thank you page based on description
          setTimeout(() => {
            if (this.description) {
              if (this.description.includes("Whitepaper")) {
                window.location.href =
                  "/download-whitepaper-document-thank-you/";
              } else if (this.description.includes("eBook")) {
                window.location.href = "/download-ebook-thank-you/";
              } else {
                window.location.href = "/download-thank-you/";
              }
            } else {
              console.error("description is undefined.");
            }
          }, 3000);
        } else {
          if (
            responseData.data &&
            responseData.data.code === 400 &&
            responseData.data.status === false &&
            responseData.data.message === "Bad request"
          ) {
            this.submissionStatus = "error";
            this.errorMessage = responseData.data.data
              ? responseData.data.data.error_list.common
              : "";
          }
        }
      } catch (error) {
        console.error("Error during form submission:", error);
      }
    },

    resetForm() {
      this.showBookForm = false;
      this.submissionStatus = "";
      this.name = "";
      this.email = "";
      this.phoneNumber = "";
      this.enteredOtp = "";
      this.otpSent = false;
      this.otpCooldown = false;
      this.errorStatus = false;
      this.errorMessage = "";
      this.selectedCountryCode = "+91";
    },
  },
};
</script>

<style scoped>
.icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: black;
  padding: 0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-button:hover {
  color: #555;
}

.icon-button svg {
  display: block;
  width: 100%;
  height: 100%;
}

.text-red-500 {
  color: #f56565;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.close-button:hover {
  color: #555;
}

.close-button svg {
  width: 24px;
  height: 24px;
}
</style>
